import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import PermissionList from 'components/Permission/List';

const ScreenPermissionList = () => (
  <GridContainer>
    <GridItem xs={12}>
      <PermissionList />
    </GridItem>
  </GridContainer>
);

export default ScreenPermissionList;
